'use client';

// eslint-disable-next-line import/no-unresolved
import { getTranslations } from 'next-intl/server';
import Error from 'next/error';

export async function generateMetadata({ params }) {
  try {
    const { locale } = params;
    const translate = await getTranslations({ locale, namespace: 'NotFound' });

    return {
      title: translate('title'),
      description: translate('description'),
    };
  } catch (error) {
    return {
      title: 'Page Not Found',
      description: 'The page you are looking for could not be found.',
    };
  }
}

export default function NotFound() {
  return (
    <html lang="en">
      <body>
        <Error statusCode={404} />
      </body>
    </html>
  );
}